var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "grcreport"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.apiType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apitype),
      expression: "apitype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "apitype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.apitype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.apiTypePlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "internal"
    }
  }, [_vm._v("Internal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "external"
    }
  }, [_vm._v("External")])])]), _vm._v(" "), (_vm.apitype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.apiTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.processName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processname),
      expression: "processname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "processname"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.processname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.processNamePlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "master"
    }
  }, [_vm._v("master")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inbound"
    }
  }, [_vm._v("inbound")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_push"
    }
  }, [_vm._v("order_push")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_handover"
    }
  }, [_vm._v("order_handover")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_picking"
    }
  }, [_vm._v("order_picking")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_allocation"
    }
  }, [_vm._v("order_allocation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_handover"
    }
  }, [_vm._v("order_handover")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_cancel"
    }
  }, [_vm._v("order_cancel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_notfound"
    }
  }, [_vm._v("order_notfound")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order_invoice"
    }
  }, [_vm._v("order_invoice")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "returns"
    }
  }, [_vm._v("returns")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("default")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('errorLogReport.selectErrorType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.errortype),
      expression: "errortype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "errortype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.errortype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('errorLogReport.errorTypePlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Internal Server Error"
    }
  }, [_vm._v("Internal Server Error")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bad Request"
    }
  }, [_vm._v("Bad Request")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Not Found"
    }
  }, [_vm._v("Not Found")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Partial_Failed"
    }
  }, [_vm._v("Partial_Failed")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.requestID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('reports.requiestIdPlaceHolder'),
      "id": "requestid"
    },
    model: {
      value: (_vm.requestid),
      callback: function($$v) {
        _vm.requestid = $$v
      },
      expression: "requestid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.status')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.StatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CREATED"
    }
  }, [_vm._v("CREATED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FAILED"
    }
  }, [_vm._v("FAILED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COMPLETED"
    }
  }, [_vm._v("COMPLETED")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('errorLogReport.fromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('errorLogReport.toDate')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.jsonbSearch')))]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-container"
  }, [_c('button', {
    staticClass: "tooltip-tarjet",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "data-toggle": "tooltip"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-element"
  }, [_c('table', [_c('tr', [_c('th', {
    staticClass: "thcss"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "thcss"
  }, [_vm._v("Example")]), _vm._v(" "), _c('th', {
    staticClass: "thcss"
  }, [_vm._v("Query\n                        "), _c('span', {
    staticClass: "info"
  }, [_vm._v(" ('payload' is column name)")])])]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JSON Objects")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.example1))]), _vm._v(" "), _c('td', [_vm._v("payload->>'pono' = 'PO04104002'")])]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Array of JSON Objects")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.example2))]), _vm._v(" "), _c('td', [_vm._v("payload->'details'->0->>'sku' = '4897116387160'")])])])])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "columnname->>'key' = 'value'",
      "id": "query"
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.gettransactionlist(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('reports.transactionLog')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 s1 o3 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 ss o4  ",
    staticStyle: {
      "padding": "5px 0px 0px 0px"
    }
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.totalrows))])]), _vm._v(" "), (_vm.download && _vm.listTransactionLogData.length > 0) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-320px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.show && _vm.listTransactionLogData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-206px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getTransactionLogReportData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listTransactionLogData.length) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-162px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download Excel"
    },
    on: {
      "click": function($event) {
        _vm.getTransactionLogReportxslData(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listTransactionLogData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-162px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listTransactionLogReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.processName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.requestID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('errorLogReport.errorType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pincodemapping.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.apiUrl')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.updatedDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.failedCount')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('errorLogReport.description')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.payloadAndResponse')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.listTransactionLogData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": " 16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('merchant.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listTransactionLogData), function(data, index) {
    return _c('tr', {
      staticClass: "cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.traceid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.errortype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.dateFormat(data.createdat)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.url))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.dateFormat(data.updatedat)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.failedcount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.errordescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                   "), _c('i', {
      staticClass: "fa fa-eye text-successeye",
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "size": "lg"
      },
      on: {
        "click": function($event) {
          _vm.copymodalopen(data.payload, data.response)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.status != 'COMPLETED') ? _c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.editmodalopen(data)
        }
      }
    }) : _vm._e(), _vm._v("  \n                  "), (data.status != 'COMPLETED') ? _c('i', {
      staticClass: "fa fa-repeat",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Retry Api"
      },
      on: {
        "click": function($event) {
          _vm.retryapi(data)
        }
      }
    }) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalrows && _vm.listTransactionLogData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalrows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e(), _vm._v(" "), _c('br')], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Payload"
    },
    model: {
      value: (_vm.isSelected),
      callback: function($$v) {
        _vm.isSelected = $$v
      },
      expression: "isSelected"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('reports.payloadAndResponse')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closecopymodal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('tbody', [_c('h6', [_vm._v(_vm._s(_vm.$t('errorLogReport.payload')) + " \n                        "), _c('i', {
    staticClass: "fa fa-copy copyIcon",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function($event) {
        _vm.copy('Payload')
      }
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.payloadData))])]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('editedjson.response')) + " \n                      "), _c('i', {
    staticClass: "fa fa-copy copyIcon",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function($event) {
        _vm.copy('Response')
      }
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.responseData))])])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Edit"
    },
    model: {
      value: (_vm.editApi),
      callback: function($$v) {
        _vm.editApi = $$v
      },
      expression: "editApi"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('editedjson.editApi')) + " ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closecopymodal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.header')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eheader),
      expression: "eheader"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxcode')
    },
    staticStyle: {
      "height": "180px"
    },
    attrs: {
      "type": "text",
      "name": "eheader",
      "id": "eheader"
    },
    domProps: {
      "value": (_vm.eheader)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eheader = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('eheader')),
      expression: "errors.has('eheader')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxCodeError')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('errorLogReport.payload')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.epayload),
      expression: "epayload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxcode')
    },
    staticStyle: {
      "height": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('editedjson.payLoadPlaceHolder'),
      "name": "epayload",
      "id": "epayload",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.epayload)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.epayload = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('epayload')),
      expression: "errors.has('epayload')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxCodeError')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.updateapi(_vm.apiid)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.updateBtn')))])])])])])])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-720e9cee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720e9cee","hasScoped":true}!./src/views/components/reports/transactionlogreport/transactionlogreport.component.html
// module id = 2059
// module chunks = 0